import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { IPackageForm } from "../models/package";
import { showError } from "../util/errorTypeEnumsOptions";

export default class PackageStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable packages: IPackageForm[] = [];
  @observable loadData = false;

  @action newPackage = async (values: IPackageForm) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.Package.newPackage(values);
      toast.success("Paquete creado satisfactoriamente.");
      this.rootStore.modalStore.closeModal();
      this.getPackages();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action getPackages = async () => {
    try {
      //id del tenant (client)
      const packages = await agent.Package.getPackages(
        this.rootStore.clienStore.client.id
      );
      runInAction(() => {
        this.packages = packages;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadData = true;
    });
  };

  @action editPackage = async (values: IPackageForm) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.Package.editPackage(values);
      toast.success("Paquete editado satisfactoriamente.");
      this.rootStore.modalStore.closeModal();
      this.getPackages();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };
}
